import { render, staticRenderFns } from "./LongElement.vue?vue&type=template&id=0f010c29&"
import script from "./LongElement.vue?vue&type=script&lang=js&"
export * from "./LongElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports